import { IGetOffersDataFormatted } from '@api/types';
import { IOption } from './interface';

export const isValidUrl = (url: string): boolean => {
    try {
        return !!new URL(url);
    } catch (err) {
        return false;
    }
};

export const replaceRedirectUrl = (url: string): string => {
    const { hostname } = new URL(url);
    const newUrl = url.replace(hostname, `redirect-${window.location.hostname}`);
    return newUrl;
};

export const getSubsArray = (subs: {
    [p: string]: string;
}): {
    key: string;
    value: string;
}[] => {
    try {
        const subList = Object.keys(subs);
        if (subList.length === 0) return [];

        const result = subList.reduce((acc, key) => {
            if (subs[key]) {
                acc.push({
                    key,
                    value: subs[key],
                });
            }
            return acc;
        }, []);

        return result;
    } catch (err) {
        console.error(err);
        return [];
    }
};

export const getOptionsValue = <T>(selectOptions: IOption<T>[], optionId: T): IOption<T> | null => {
    return selectOptions.find(option => option.value === optionId) || null;
};

export const getOfferNames = (offersData: IGetOffersDataFormatted[]): { [key: string]: string } => {
    return offersData.reduce(
        (obj, { id, name }) => ({
            ...obj,
            [id]: name,
        }),
        {},
    );
};
